import React, { useEffect, useState } from "react";
import {
  Navigate,
  Outlet,
  useLocation,
} from "react-router-dom";
import api from "../api";

const LoadingScreen = () => (
  <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-amber-50 to-orange-50">
    <div className="text-center">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-amber-600 mx-auto mb-4"></div>
      <p className="text-amber-700 font-medium">
        Checking privacy acknowledgement...
      </p>
    </div>
  </div>
);

const ProtectedPrivacyRoute = () => {
  const location = useLocation();

  const [loading, setLoading] = useState(true);
  const [accepted, setAccepted] = useState(false);

  useEffect(() => {
    const checkPrivacyAcceptance = async () => {
      try {
        const res = await api.get("maturity/privacy/current/");

        if (
          res.data?.has_notice &&
          res.data?.accepted
        ) {
          setAccepted(true);
        } else {
          setAccepted(false);
        }
      } catch (err) {
        console.error("Privacy check failed:", err);
        setAccepted(false);
      } finally {
        setLoading(false);
      }
    };

    checkPrivacyAcceptance();
  }, []);

  if (loading) {
    return <LoadingScreen />;
  }

  if (!accepted) {
    const framework = location.pathname.startsWith("/bcm")
      ? "bcm"
      : "cobit";

    return (
      <Navigate
        to="/privacy-notice"
        replace
        state={{
          framework,
          redirectTo: location.pathname,
        }}
      />
    );
  }

  return <Outlet />;
};

export default ProtectedPrivacyRoute;